import { Button, ButtonProps } from '@/libraries/ui'

export function AddButton(props: ButtonProps) {
  return <Button icon="add" {...props} />
}
